module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/13.a387aeaf.png";